import React from "react";
import PropTypes from "prop-types";
import ButtonComponent from "./ButtonComponent";

export default function InputLabelButtonComponent(props) {
  // RENDER
  /////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="c-input">
      <div className="c-input__label">{props.label}</div>
        <ButtonComponent
          className="c-button"
          label={props.btnCta}
          onClick={() => props.btnOnClick()}
        />
    </div>
  );
}

InputLabelButtonComponent.propTypes = {
  btnOnClick: PropTypes.func,
  label: PropTypes.string,
  btnCta: PropTypes.string,
};